import VolanteDetailCpt from "../VolanteDetail/VolanteDetail";
import { DetailsHeader } from "./VolanteDetailsStyles";

function VolanteDetails(props) {
  const { isTotal, onRemoveClick, quotationDetails, disableServices, volante } =
    props;

  const details = disableServices
    ? quotationDetails.filter(
        (detail) => detail.category !== "additional_service"
      )
    : quotationDetails;
  return (
    <>
      <DetailsHeader>
        <div>Descripción</div>
        <div>Valor Venta</div>
        <div className="discount">Descuento</div>
        <div>Neto</div>
        <div>IGV</div>
        <div className="selling-price">Precio Venta</div>
        <div>Cantidad</div>
      </DetailsHeader>
      <div>
        {details.map((detail) => (
          <VolanteDetailCpt
            volante={volante}
            key={detail.id}
            detail={detail}
            isTotal={isTotal}
            onRemoveClick={onRemoveClick}
          />
        ))}
      </div>
    </>
  );
}

export default VolanteDetails;
